import { gql } from '@apollo/client';

export const GET_SERVICE = gql`
  query GetService($id: ID!) {
    service: getService(id: $id) {
      id
      name
      description
      startDate
      endDate
      status
    }
  }
`;
